import {store} from "../helper/store";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";

export const addMouseMoveListener = (element, mousemove) => {

	const mouseup = () => {
		window.removeEventListener('mousemove', mousemove);
		window.removeEventListener('mouseup', mouseup);
	}

	const mousedown = () => {
		window.addEventListener('mousemove', mousemove);
		window.addEventListener('mouseup', mouseup);
	}

	element.addEventListener('mousedown', mousedown);
}

/* Function has some side effects, better to use window.addEventListener,
   if there is component refresh during keyboard action.
   Usually triggers multiple events when using this function */
export const addKeyboardListener = (element, keyDown, keyUp) => {

	let down = false;

	const keyup = (event) => {
		window.removeEventListener('keyup', keyup);
		down = false;
		keyUp && keyUp(event);
	}

	const keydown = (event) => {
		window.addEventListener('keyup', keyup);
		if (!down) {
			keyDown && keyDown(event);
			down = true;
		}
	}

	element.addEventListener('keydown', keydown);
}

export const removeKeyboardListeners = (element, keyDown) =>
	element.removeEventListener('keydown', keyDown);


export const addWheelListener = (element, onWheel) => {
	element.addEventListener('wheel', onWheel);
}

export const removeWheelListener = (element, onWheel) => {
	element.removeEventListener('wheel', onWheel);
}

export const isPermitted = event => {
	let {keyboard_shortcuts} = store.getState().morpheusSettingReducer;
	return keyboard_shortcuts['enabled'] && hasPermissions([aclPermissions.keyboard_shortcuts_app]) &&
		event.target.tagName !== 'INPUT' && !event.shiftKey && (!event.ctrlKey || !event.metaKey) && !event.altKey;
}

export const isCtrlPermitted = event => {
	let {keyboard_shortcuts} = store.getState().morpheusSettingReducer;
	return keyboard_shortcuts['enabled'] && hasPermissions([aclPermissions.keyboard_shortcuts_app]) &&
		event.target.tagName !== 'INPUT' && !event.shiftKey && !event.altKey;
}

export const isShiftShortcutPermitted = event => {
	let {keyboard_shortcuts} = store.getState().morpheusSettingReducer;
	return keyboard_shortcuts['enabled'] && hasPermissions([aclPermissions.keyboard_shortcuts_app]) &&
		event.target.tagName !== 'INPUT' && (!event.ctrlKey || !event.metaKey) && !event.altKey;
}

export const isShiftPermitted = event => {
	return event.target.tagName !== 'INPUT' && (!event.ctrlKey || !event.metaKey) && !event.altKey;
}